/**
 * Created by Ivan on 27.09.2025
 */

const RaveReviews = function () {
    cleverapps.EventEmitter.call(this);

    this.updateInfo();

    this.customIcon = RaveReviewsIcon;

    this.onGetView = () => {};
};

RaveReviews.prototype = Object.create(cleverapps.EventEmitter.prototype);
RaveReviews.prototype.constructor = RaveReviews;

RaveReviews.prototype.updateInfo = function (info) {
    const data = info || cleverapps.dataLoader.load(DataLoader.TYPES.RAVE_REVIEWS) || {};
    this.points = data.points || 0;
    this.stage = data.stage || 0;
    this.badgedOrders = data.orders || [];
};

RaveReviews.prototype.save = function () {
    this.badgedOrders = this.listBadgedOrders();
    cleverapps.dataLoader.save(DataLoader.TYPES.RAVE_REVIEWS, this.getInfo());
};

RaveReviews.prototype.getInfo = function () {
    return {
        points: this.points,
        stage: this.stage,
        orders: this.badgedOrders
    };
};

RaveReviews.prototype.listBadgedOrders = function () {
    return Merge2.current.customers.listCustomersWithRecipe()
        .filter((customer) => customer.hasRaveReviewsReward())
        .map((customer) => customer.recipe.index);
};

RaveReviews.prototype.isOrderBadged = function (index) {
    return index !== undefined && this.badgedOrders.includes(index);
};

RaveReviews.prototype.addPoints = function (value, silent) {
    if (!this.isAvailable()) {
        return;
    }

    this.points += value;
    this.save();

    if (this.isCompleted()) {
        this.resetReviews();
    }

    if (!silent) {
        this.trigger("updateState");
    }
};

RaveReviews.prototype.resetReviews = function () {
    Merge2.current.customers.listCustomersWithRecipe().forEach((customer) => {
        customer.setRaveReviewsReward(false, true);
    });

    this.save();
};

RaveReviews.prototype.calcPoints = function () {
    return Math.min(this.points, this.calcGoal());
};

RaveReviews.prototype.calcGoal = function () {
    if (this.stage < RaveReviews.POINTS_TARGETS.length) {
        return RaveReviews.POINTS_TARGETS[this.stage];
    }

    return 12;
};

RaveReviews.prototype.calcAvailableReviews = function () {
    if (this.reviewsPaused) {
        return 0;
    }

    return Math.max(0, this.calcGoal() - this.points);
};

RaveReviews.prototype.calcOrderReward = function (stars) {
    return stars > 50 ? 2 : 1;
};

RaveReviews.prototype.isAvailable = function () {
    return levels.user.checkAvailable(cleverapps.config.availables.RAVE_REVIEWS);
};

RaveReviews.prototype.isCompleted = function () {
    return this.points >= this.calcGoal();
};

RaveReviews.prototype.calcRewardsPool = function () {
    const list = [];
    const customers = Merge2.current.customers.listCustomersWithRecipe();

    if (customers.length) {
        customers.forEach((customer) => {
            customer.recipe.ingredients.forEach((ingredient) => {
                list.push(ingredient.unit);
            });
        });
    } else {
        const openLines = Object.keys(Families).filter((code) => Families[code].type === "resource");
        openLines.forEach((line) => {
            cleverapps.unitsLibrary.listOpened(line).forEach((unit) => {
                list.push(unit);
            });
        });
    }
    return list.filter((unit) => !Unit.isSideQuest(unit.code)).map((unit) => {
        const minStage = Math.max(0, unit.stage - 5);
        const maxStage = Math.min(6, unit.stage);

        return {
            code: unit.code,
            stage: PseudoRandom.GET().random(minStage, maxStage)
        };
    });
};

RaveReviews.prototype.calcRewards = function () {
    if (!this.isAvailable()) {
        return [];
    }

    const prizesAmount = this.calcGoal() + PseudoRandom.GET().random(-2, 2);
    const rewardsPool = this.calcRewardsPool();

    if (!rewardsPool.length) {
        return [];
    }

    const rewards = PseudoRandom.GET().chooseN(rewardsPool.slice(), prizesAmount);
    while (rewards.length < prizesAmount) {
        rewards.push(PseudoRandom.GET().choose(rewardsPool));
    }

    return rewards;
};

RaveReviews.prototype.checkReward = function () {
    if (!this.isCompleted()) {
        return;
    }

    this.giveReward();
};

RaveReviews.prototype.calcRewardDuration = function (rewards) {
    const mapUnits = Math.min(rewards.length, Merge2.current.field.countEmptySlots());
    const bubbleStackUnits = Math.max(0, rewards.length - mapUnits);
    return Math.max(mapUnits * 0.1 + 0.75, mapUnits * 0.1 + bubbleStackUnits * 0.3 + 0.3);
};

RaveReviews.prototype.giveReward = function () {
    cleverapps.focusManager.display({
        focus: "RaveReviewsReward",
        stack: true,
        keepControls: true,
        actions: [
            (f) => {
                this.reviewsPaused = true;

                this.points = 0;
                this.stage++;
                this.save();

                Merge2.current.customers.clearCooldown();
                if (cleverapps.tutorial.isActive()) {
                    Merge2.current.customers.makeNewOrders();
                }

                this.trigger("updateState");
                f();
            },
            (f) => {
                const rewards = this.calcRewards();
                const duration = this.calcRewardDuration(rewards);

                this.trigger("giveReward", rewards, duration);

                cleverapps.timeouts.setTimeout(f, duration * 1000);
            },
            (f) => {
                this.startNextStage(f);
            }
        ]
    });
};

RaveReviews.prototype.startNextStage = function (f) {
    new RaveReviewsStartWindow(() => {
        this.reviewsPaused = false;

        Merge2.current.customers.addReviews();
    });
    cleverapps.focusManager.onceNoWindowsListener = f;
};

RaveReviews.prototype.handleClick = function () {
    cleverapps.focusManager.display({
        focus: "RaveReviewsWindow",
        keepControls: true,
        stack: true,
        action: function (f) {
            new RaveReviewsWindow();
            cleverapps.focusManager.onceNoWindowsListener = f;
        }
    });
};

cleverapps.InitByFeature["rave_reviews"] = function () {
    cleverapps.raveReviews = new RaveReviews();
};

RaveReviews.REWARDS_AMOUNT = 5;
RaveReviews.POINTS_TARGETS = [6, 6, 8, 8, 8, 8, 8, 10, 10];